/*
 * AI search panel (snippets/ai-search-panel.liquid). Takes over the header search
 * trigger: opens at the top of the page on desktop and full screen on mobile. Before
 * the shopper types it shows suggested questions, popular searches, a featured review,
 * the latest article and featured products; while they type, AI-ranked products,
 * reviews that mention the search, articles, and a button to the matching collection.
 * Falls back to Shopify predictive search when the AI service is unavailable; if this
 * script never runs, the trigger keeps its plain /search link.
 */
(function () {
  var C = window.AISearchClient;
  var root = document.querySelector('[data-ais]');
  var D = C && C.panelData();
  if (!C || !C.ready() || !root || !D) return;

  var L = D.labels, N = D.counts, R = D.reviews;
  var esc = C.escapeHtml;
  var SURFACE = 'header';
  var input = root.querySelector('[data-ais-input]');
  var form = root.querySelector('[data-ais-form]');
  var body = root.querySelector('[data-ais-body]');
  var featured = (root.querySelector('[data-ais-featured]') || {}).innerHTML || '';
  featured = featured.trim();
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function globs(list) {
    return (list || []).map(function (p) {
      return new RegExp('^' + p.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*') + '$', 'i');
    });
  }
  var exclude = globs(D.exclude);
  var popularHide = globs(D.popularHide);
  function showable(term) { return !popularHide.some(function (re) { return re.test(String(term || '').trim()); }); }

  var s = { term: '', answer: '', seq: 0, ctrl: null, opener: null, rv: 0, rotate: null, debounce: null, type: null, handles: [], popular: (D.popular || []).filter(showable).slice(0, N.popular), trendingLoaded: false };

  // ---- helpers -------------------------------------------------------------------

  function fill(label, vars) {
    return String(label || '').replace(/\[(\w+)\]/g, function (m, k) { return k in vars ? vars[k] : m; });
  }

  function section(label, content, link) {
    return '<div class="ais-sec"><div class="ais-lbl"><span>' + esc(label) + '</span>' + (link || '') + '</div>' + content + '</div>';
  }

  function excerpt(text, term) {
    var words = C.termWords(term), max = R.excerpt, low = text.toLowerCase();
    var first = words.reduce(function (m, w) { var i = low.indexOf(w); return i >= 0 && i < m ? i : m; }, Infinity);
    var start = first === Infinity || first < max / 2 ? 0 : text.indexOf(' ', Math.floor(first - max / 3)) + 1;
    var end = start + max < text.length ? text.lastIndexOf(' ', start + max) : text.length;
    if (end <= start) end = Math.min(text.length, start + max);
    var html = esc(text.slice(start, end).trim());
    words.forEach(function (w) { html = html.replace(C.wordPattern(esc(w)), '$1<b>$2</b>'); });
    return (start > 0 ? '…' : '') + html + (end < text.length ? '…' : '');
  }

  function stars(n) {
    return '<span class="ais-stars" aria-label="' + n + ' / 5">' + new Array(n + 1).join('★') + '</span>';
  }

  function reviewCard(r, i, term, kind) {
    var p = r.product;
    return '<a class="ais-rv ais-rv--' + kind + '" href="' + esc(p.url) + '"' + C.aiAttrs(p.handle, 'review', i + 1, SURFACE) + '>' +
      (kind === 'featured' && p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') +
      '<span class="ais-rv__c">' + stars(r.rating) +
      (kind === 'featured' && r.title ? '<span class="ais-rv__t">' + esc(r.title) + '</span>' : '') +
      '<span class="ais-rv__b">&ldquo;' + excerpt(r.body, term) + '&rdquo;</span>' +
      '<span class="ais-rv__m">' + esc(r.reviewer) + ' · <b>' + esc(p.title) + '</b></span></span></a>';
  }

  function collectionFor(term) {
    var t = term.toLowerCase().trim();
    var link = (D.links || []).filter(function (l) { return l.term.toLowerCase() === t; })[0];
    if (link) return link;
    var words = t.split(/\s+/).filter(Boolean);
    if (!words.length) return null;
    return (D.collections || []).filter(function (c) {
      return !exclude.some(function (re) { return re.test(c.h); });
    }).map(function (c) {
      var title = c.t.toLowerCase();
      return { c: c, at: words.every(function (w) { return title.indexOf(w) >= 0; }) ? title.indexOf(words[0]) : -1 };
    }).filter(function (x) { return x.at >= 0 && x.c.n > 0; })
      .sort(function (a, b) { return a.at - b.at || b.c.n - a.c.n; })
      .map(function (x) { return x.c; })[0] || null;
  }

  function destination(term, total) {
    var c = collectionFor(term);
    return c
      ? { url: c.u, label: fill(esc(L.shopCollection), { title: esc(c.t), count: c.n }), short: esc(L.shopShort) }
      : { url: C.cfg.searchUrl + '?q=' + encodeURIComponent(term), label: fill(esc(L.seeAll), { count: total, terms: esc(term) }), short: fill(esc(L.seeAllShort), { count: total }) };
  }

  // ---- empty state ---------------------------------------------------------------

  function featuredReviews() {
    return C.reviews().filter(function (r) { return r.product.image && r.body.length >= R.excerpt / 3; }).slice(0, R.featured);
  }

  function lovedHtml() {
    var list = featuredReviews();
    if (!list.length) return '';
    var r = list[s.rv % list.length];
    var dots = list.length > 1 ? '<div class="ais-dots">' + list.map(function (_, i) {
      return '<button type="button" class="' + (i === s.rv % list.length ? 'is-on' : '') + '" data-ais-dot="' + i + '" aria-label="' + (i + 1) + '"></button>';
    }).join('') + '</div>' : '';
    return reviewCard(r, s.rv % list.length, '', 'featured') + dots;
  }

  function emptyHtml() {
    var left = '', right = '';
    if (D.questions.length) {
      left += section(L.questions, '<div class="ais-qs">' + D.questions.map(function (q, i) {
        return '<button type="button" class="ais-q" data-ais-question="' + i + '"><span>' + esc(q.q) + '</span><span aria-hidden="true">&rarr;</span></button>';
      }).join('') + '</div>');
    }
    if (s.popular.length) {
      left += section(L.popular, '<div class="ais-chips">' + s.popular.map(function (t) {
        return '<button type="button" class="ais-chip" data-ais-term="' + esc(t) + '">' + esc(t) + '</button>';
      }).join('') + '</div>');
    }
    right += '<div data-ais-loved>' + (featuredReviews().length ? section(L.loved, lovedHtml()) : '') + '</div>';
    if (D.latest) {
      right += section(L.blog, '<a class="ais-blog" href="' + esc(D.latest.url) + '"' + C.aiAttrs(D.latest.url, 'article', 1, SURFACE) + '>' +
        (D.latest.image ? '<img src="' + esc(D.latest.image) + '" alt="" loading="lazy">' : '') +
        '<span><span class="ais-blog__t">' + esc(D.latest.title) + '</span><span class="ais-blog__r">' + esc(L.read) + ' &rarr;</span></span></a>',
        D.blogUrl ? '<a href="' + esc(D.blogUrl) + '">' + esc(L.blogAll) + '</a>' : '');
    }
    var html = '<div class="ais-empty"><div>' + left + '</div><div>' + right + '</div></div>';
    if (featured) {
      html += section(L.featured, '<div class="ais-row">' + featured + '</div>',
        D.featuredUrl ? '<a href="' + esc(D.featuredUrl) + '">' + esc(L.featuredAll) + '</a>' : '');
    }
    return html;
  }

  function paintLoved() {
    var box = body.querySelector('[data-ais-loved]');
    if (box) box.innerHTML = featuredReviews().length ? section(L.loved, lovedHtml()) : '';
  }

  function startRotate() {
    stopRotate();
    if (R.rotate > 0 && !reduceMotion) s.rotate = setInterval(function () { s.rv++; paintLoved(); }, R.rotate * 1000);
  }
  function stopRotate() { clearInterval(s.rotate); s.rotate = null; }

  // Most searched terms of the month that pass a quality gate (enough searches, and
  // the search still finds products), topped up from the popular searches setting.
  // Verified terms are kept for the browser session.
  function loadPopular() {
    if (s.trendingLoaded) return;
    s.trendingLoaded = true;
    var key = 'ais-popular:2:' + N.popular + ':' + N.popularMin + ':' + (D.popularHide || []).join('|');
    var cached;
    try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    var verified = cached ? Promise.resolve(cached) : C.trending(N.popular * 2, true).then(function (top) {
      var words = top.map(function (q) { return String(q.query || '').toLowerCase().trim(); });
      var terms = top.filter(function (q, i) {
        // "uro" logged next to "urolithin" is the same search typed partway, not a second popular term.
        var fragment = words.some(function (o, j) { return j !== i && o.length > words[i].length && o.indexOf(words[i]) === 0; });
        return q.count >= N.popularMin && !fragment && showable(words[i]);
      }).map(function (q) { return q.query; });
      return Promise.all(terms.map(function (t) {
        return C.query(t).then(function (d) { return d && d.products && d.products.length ? t : null; }, function () { return null; });
      })).then(function (ok) {
        ok = ok.filter(Boolean);
        try { sessionStorage.setItem(key, JSON.stringify(ok)); } catch (e) {}
        return ok;
      });
    });
    verified.then(function (top) {
      var seen = {}, merged = [];
      top.concat(D.popular || []).forEach(function (t) {
        var k = String(t || '').toLowerCase().trim();
        if (k && !seen[k] && showable(k)) { seen[k] = 1; merged.push(t); }
      });
      s.popular = merged.slice(0, N.popular);
      if (!s.term && !root.hidden) render();
    });
  }

  // ---- results -------------------------------------------------------------------

  // Shopify's own predictive search, shaped like the AI service response.
  function nativeSearch(term, signal) {
    var url = C.cfg.predictiveUrl + '.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product,article&resources[limit]=' + Math.max(N.products, N.articles, 1);
    return fetch(url, { signal: signal }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      var res = (d && d.resources && d.resources.results) || {};
      return {
        products: (res.products || []).map(function (p) { return { slug: p.handle, url: p.url, title: p.title, image: p.image, price: p.price }; }),
        articles: (res.articles || []).map(function (a) { return { slug: a.handle, url: a.url, title: a.title }; }),
      };
    });
  }

  function suggestions(term, data) {
    var t = term.toLowerCase().trim(), seen = {}, out = [];
    [data.didYouMean].concat(s.popular, D.questions.map(function (q) { return q.t; })).forEach(function (x) {
      var k = String(x || '').toLowerCase().trim();
      if (k && !seen[k] && k !== t && (k.indexOf(t) >= 0 || x === data.didYouMean)) { seen[k] = 1; out.push(x); }
    });
    return out.slice(0, N.suggestions);
  }

  function highlight(text, term) {
    var t = term.trim(), i = text.toLowerCase().indexOf(t.toLowerCase());
    return i < 0 || !t ? esc(text) : esc(text.slice(0, i)) + '<b>' + esc(text.slice(i, i + t.length)) + '</b>' + esc(text.slice(i + t.length));
  }

  function reviewsHtml(term) {
    var list = C.matchReviews(term, s.handles, R.count);
    return list.length ? section(L.shoppers, list.map(function (r, i) { return reviewCard(r, i, term, 'match'); }).join('')) : '';
  }

  function paintMatches() {
    var box = body.querySelector('[data-ais-revs]');
    if (box && s.term) box.innerHTML = reviewsHtml(s.term);
  }

  function resultsHtml(term, data, cards) {
    var all = data.products || [];
    var dest = destination(term, all.length);
    var sugg = suggestions(term, data);
    var articles = (data.articles || []).slice(0, N.articles);
    var main = s.answer ? '<div class="ais-answer">' + esc(s.answer) + '</div>' : '';
    if (cards.count) {
      main += section(L.products, '<div class="ais-grid">' + cards.html + '</div>',
        '<a href="' + esc(dest.url) + '">' + dest.short + '</a>') +
        '<a class="ais-all btn btn--primary btn--full" href="' + esc(dest.url) + '">' + dest.label + '</a>';
    } else {
      main += '<p class="ais-none">' + fill(esc(L.noMatch), { terms: esc(term) }) + '</p>' +
        (featured ? '<div class="ais-grid">' + featured + '</div>' : '');
    }
    return '<div class="ais-res">' +
      '<div class="ais-res__main">' + main + '</div>' +
      '<div class="ais-res__sugg">' + (sugg.length ? section(L.suggestions, sugg.map(function (x) {
        return '<button type="button" class="ais-sug" data-ais-term="' + esc(x) + '">' + highlight(x, term) + '</button>';
      }).join('')) : '') + '</div>' +
      '<div class="ais-res__revs" data-ais-revs>' + reviewsHtml(term) + '</div>' +
      '<div class="ais-res__arts">' + (articles.length ? section(L.articles, '<div class="ais-arts">' + articles.map(function (a, i) {
        return '<a class="ais-art" href="' + esc(a.url) + '"' + C.aiAttrs(a.slug, 'article', cards.count + i + 1, SURFACE) + '>' + esc(a.title) + '</a>';
      }).join('') + '</div>') : '') + '</div>' +
      '</div>';
  }

  function search(term) {
    var seq = ++s.seq;
    if (s.ctrl) s.ctrl.abort();
    s.ctrl = window.AbortController ? new AbortController() : null;
    var signal = s.ctrl && s.ctrl.signal;
    root.classList.add('is-loading');
    C.query(term, { signal: signal })
      .then(function (data) { return data || nativeSearch(term, signal); })
      .then(function (data) {
        data = data || { products: [], articles: [] };
        var products = data.products || [];
        s.handles = products.map(function (p) { return p.slug; });
        return C.renderProducts(products.slice(0, N.products), 'ai-card', SURFACE).then(function (cards) {
          if (seq !== s.seq) return;
          body.innerHTML = resultsHtml(term, data, cards);
          try { if (window.AISearchAnalytics) window.AISearchAnalytics.logSearch(term, products.length, SURFACE); } catch (e) {}
        });
      })
      .catch(function () {})
      .then(function () { if (seq === s.seq) root.classList.remove('is-loading'); });
  }

  function render() {
    root.classList.toggle('has-term', !!input.value);
    if (s.term.trim()) { search(s.term.trim()); return; }
    s.seq++;
    root.classList.remove('is-loading');
    body.innerHTML = emptyHtml();
  }

  function setTerm(term, answer) {
    s.term = term;
    s.answer = answer || '';
    render();
  }

  function typeIn(text, term, answer) {
    clearInterval(s.type);
    if (!N.typeMs || reduceMotion) { input.value = text; setTerm(term, answer); return; }
    var i = 0;
    input.value = '';
    s.type = setInterval(function () {
      input.value = text.slice(0, ++i);
      if (i >= text.length) { clearInterval(s.type); setTerm(term, answer); }
    }, N.typeMs);
  }

  // ---- open / close --------------------------------------------------------------

  // Desktop: the bar sits exactly over the theme header, with the header's own logo.
  function placeBar() {
    var header = document.querySelector('[data-section-type="header"]');
    var rect = header && header.getBoundingClientRect();
    root.style.setProperty('--ais-top', Math.max(0, rect ? rect.top : 0) + 'px');
    if (rect && rect.height) root.style.setProperty('--ais-bar', rect.height + 'px');
    var slot = root.querySelector('[data-ais-logo]');
    var logo = header && header.querySelector('.header__logo-link');
    if (slot && logo && !slot.childNodes.length) {
      Array.prototype.forEach.call(logo.childNodes, function (n) { slot.appendChild(n.cloneNode(true)); });
    }
  }

  function open(opener) {
    if (!root.hidden) return;
    s.opener = opener || null;
    placeBar();
    root.hidden = false;
    document.documentElement.classList.add('ais-open');
    if (s.opener) s.opener.setAttribute('aria-expanded', 'true');
    if (!input.value) s.term = s.answer = '';
    render();
    startRotate();
    loadPopular();
    C.loadReviews();
    setTimeout(function () { input.focus(); }, 0);
  }

  function close() {
    if (root.hidden) return;
    root.hidden = true;
    document.documentElement.classList.remove('ais-open');
    stopRotate();
    clearInterval(s.type);
    if (s.opener) { s.opener.setAttribute('aria-expanded', 'false'); s.opener.focus(); }
  }

  // ---- events --------------------------------------------------------------------

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-search]');
    if (!t || root.contains(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(t);
  }, true);

  C.onReviews(function () {
    if (root.hidden) return;
    if (s.term) paintMatches(); else paintLoved();
  });

  input.addEventListener('input', function () {
    clearInterval(s.type);
    clearTimeout(s.debounce);
    root.classList.toggle('has-term', !!input.value);
    s.debounce = setTimeout(function () { setTerm(input.value); }, N.debounceMs);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var term = (s.term || input.value).trim();
    if (!term) return;
    window.location.href = destination(term, 0).url;
  });

  root.addEventListener('click', function (e) {
    var el = e.target.closest('[data-ais-close],[data-ais-clear],[data-ais-question],[data-ais-term],[data-ais-dot]');
    if (!el) return;
    if (el.hasAttribute('data-ais-close')) { close(); return; }
    if (el.hasAttribute('data-ais-clear')) { clearInterval(s.type); input.value = ''; setTerm(''); input.focus(); return; }
    if (el.hasAttribute('data-ais-dot')) { s.rv = Number(el.getAttribute('data-ais-dot')); paintLoved(); startRotate(); return; }
    if (el.hasAttribute('data-ais-question')) {
      var q = D.questions[Number(el.getAttribute('data-ais-question'))];
      if (q) typeIn(q.q, q.t, q.a);
      return;
    }
    var term = el.getAttribute('data-ais-term');
    typeIn(term, term);
  });

  document.addEventListener('keydown', function (e) {
    // Escape in a search field also clears it by default; here it only closes.
    if (e.key === 'Escape' && !root.hidden) { e.preventDefault(); close(); }
  });
})();
